module.exports = __webpack_public_path__ + "static/media/send-enable.796cb4ec.svg";